import axios from 'axios';
import { getAuthToken } from '../auth/auth';
import { logAPILatency } from '../monitor/log';

const getAuthHeader = async () => {
  const token = await getAuthToken();
  return { Authorization: token }
};

const get = async (api_name, endpoint) => {
  const startTimeMs = performance.now();
  const headers = await getAuthHeader();
  const data = (await axios.get(endpoint, { headers })).data;
  const endTimeMs = performance.now();
  logAPILatency(api_name, endTimeMs - startTimeMs);
  return data;
}

const post = async (api_name, endpoint, data) => {
  const startTimeMs = performance.now();
  const headers = await getAuthHeader();
  await axios.post(endpoint, data, { headers });
  const endTimeMs = performance.now();
  logAPILatency(api_name, endTimeMs - startTimeMs);
}

const put = async (api_name, endpoint, data) => {
  const startTimeMs = performance.now();
  const headers = await getAuthHeader();
  await axios.put(endpoint, data, { headers });
  const endTimeMs = performance.now();
  logAPILatency(api_name, endTimeMs - startTimeMs);
}

const del = async (api_name, endpoint) => {
  const startTimeMs = performance.now();
  const headers = await getAuthHeader();
  await axios.delete(endpoint, { headers });
  const endTimeMs = performance.now();
  logAPILatency(api_name, endTimeMs - startTimeMs);
}

export {
  get,
  post,
  put,
  del
}